export default {
  users: [],
  user: [],
  loggingIn: false,
  info: null,
  rating: 0
};
